export const clinic = {
  name: 'Clinic name to be confirmed',
  address: 'Clinic address will be added before launch',
  mapUrl: '',
  hours: [
    { day: 'Monday – Friday', time: 'Hours to be confirmed' },
    { day: 'Saturday', time: 'Hours to be confirmed' },
    { day: 'Sunday', time: 'Availability to be confirmed' },
  ],
  notice: 'Consultation times may change with clinic availability. Confirmed appointments receive the latest timing.',
}

export const doctorProfile = {
  name: 'Dr. Fathima Finu M. P.',
  title: 'General Doctor',
  summary: 'A medical practitioner with experience across general medicine, critical care, inpatient and outpatient care, focused on clear communication and thoughtful clinical collaboration.',
  education: 'MBBS, Government Medical College Ernakulam',
  languages: ['Malayalam', 'English', 'Hindi'],
  interests: ['Patient safety', 'Point-of-care diagnostics', 'Physiological monitoring', 'Practical health technology'],
  linkedin: 'https://www.linkedin.com/in/fathima-finu-3330123b8',
}

export const patientApps = [
  {
    name: 'Nutrition Companion',
    status: 'In development',
    label: 'Diet control, without diet culture',
    description: 'A gentle Android companion for meal awareness, hydration, habit patterns, and goals you can actually live with. Designed to support—not replace—professional nutrition or medical care.',
    features: ['Simple meal and water check-ins', 'Flexible routines, not rigid streaks', 'Shareable progress summaries', 'Privacy-first local controls'],
    accent: 'lime',
    link: '',
  },
  {
    name: 'Patient Helper',
    status: 'In development',
    label: 'Fewer loose ends after a visit',
    description: 'A practical patient organizer for questions, medication lists, follow-up reminders, and documents—so the next health conversation starts with better context.',
    features: ['Prepare questions before a visit', 'Keep a current medicines list', 'Organize non-urgent follow-ups', 'Export a concise visit brief'],
    accent: 'aqua',
    link: '',
  },
]
